import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleFavorite } from '../Actions/FavoriteIcon.action';

const FavoriteIcon = (props) => {
    const [active, setactive] = useState(false);
    const dispatch = useDispatch();
    const favoriteProducts = useSelector((state) => state.favoriteProducts.products);

    useEffect(() => {
        if (favoriteProducts && favoriteProducts.length > 0) {
            const favoriteProduct = favoriteProducts.find(x => x.id === props.articleNumber);
            if (favoriteProduct) {
                setactive(true);
            }
        }
    }, [favoriteProducts]);      
    return (<Fragment>
        <span className={`favorite__icon ${active ? 'active' : ''}`} onClick={() => dispatch(toggleFavorite(props.articleNumber, event))}>
            <svg>
                {active ?
                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#heart-filled"></use>
                    :
                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#heart"></use>
                }
            </svg>
        </span>
    </Fragment>);
}

export default FavoriteIcon;
